import React from 'react';
import flow from 'lodash/flow';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import {
	hideInsertLoomLinkForm,
	showInsertLoomLinkForm,
} from '@atlassian/jira-issue-view-store/src/actions/loom-actions.tsx';
import {
	createWebLinkRequest,
	deleteWebLinkRequest,
} from '@atlassian/jira-issue-view-store/src/actions/web-links-actions.tsx';
import {
	isInsertLoomLinkOpenedSelector,
	insertLoomLinkClickedCountSelector,
} from '@atlassian/jira-issue-view-store/src/selectors/loom-selector.tsx';
import {
	webLinksWithApplicationIdSelector,
	generateApplicationId,
} from '@atlassian/jira-issue-view-store/src/selectors/web-links-selector.tsx';
import { toHref, type WebLinkId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { OwnProps, StateProps, DispatchProps } from './types.tsx';
import { LoomCoUseView } from './view.tsx';

const LOOM_APP_NAME = 'Loom';
const LOOM_APP_TYPE = 'com.atlassian.jira.issue.loom';

const ReduxConnectedView = flow(
	connect<StateProps, DispatchProps, OwnProps>(
		(state): StateProps => ({
			isInsertLoomLinkOpened: isInsertLoomLinkOpenedSelector(state),
			insertLoomLinkClickedCount: insertLoomLinkClickedCountSelector(state),
			links: webLinksWithApplicationIdSelector(
				state,
				generateApplicationId(LOOM_APP_NAME, LOOM_APP_TYPE),
			),
		}),
		(dispatch) => ({
			onInsertLink: (url: string) =>
				dispatch(
					createWebLinkRequest(toHref(url), 'Loom video', '', {
						type: LOOM_APP_TYPE,
						name: LOOM_APP_NAME,
					}),
				),
			onDeleteLink: (id: WebLinkId) => dispatch(deleteWebLinkRequest(id)),
			onShowInsertLoomLinkForm: () => dispatch(showInsertLoomLinkForm()),
			onHideInsertLoomLinkForm: () => dispatch(hideInsertLoomLinkForm()),
		}),
	),
)(LoomCoUseView);

export const LoomCoUsePanel = (props: OwnProps): React.JSX.Element => (
	<JSErrorBoundary
		id="loom-videos-section-container"
		packageName="issueViewBase"
		teamName="bento"
		fallback="flag"
	>
		<ReduxConnectedView {...props} />
	</JSErrorBoundary>
);
